import __ from '@/libraries/Translation';

export default function userFields() {
  return [
    {
      id: 'name',
      name: 'name',
      label: __('form.name_title'),
      placeholder: '',
      value: null,
      component: 'TextField',
      visibility: 'default',
      rules: ['required']
    },
    {
      id: 'surname',
      name: 'surname',
      label: __('form.surname_title'),
      placeholder: '',
      value: null,
      component: 'TextField',
      visibility: 'default',
      rules: ['required']
    },
    {
      id: 'email',
      name: 'email',
      label: __('form.email_title'),
      placeholder: '',
      value: null,
      component: 'TextField',
      visibility: 'default',
      rules: ['email', 'required']
    },
    {
      id: 'phone',
      name: 'phone',
      label: __('form.phone_title'),
      placeholder: '',
      value: null,
      component: 'PhoneField',
      visibility: 'default',
      rules: ['required']
    },
    {
      id: 'agree_terms',
      name: 'agree_terms',
      label: '',
      placeholder: '',
      value: null,
      component: 'BooleanField',
      visibility: 'agreeTerms',
      rules: ['required']
    }
  ];
}
